// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__Sn6NQ","paramInput":"JobSimulator_paramInput__2H4sC","input":"JobSimulator_input__2rOHV"};